<div class="flex flex-column" [class.page-padded]="!flush()">
  <!-- Title, subtitle, avatar/icon, and buttons -->
  <div class="flex flex-column gap-1 w-full">
    <div class="page-header-row flex justify-content-between align-items-center w-full">
      <!-- Left side: Back button + avatar + title/description -->
      <div class="flex flex-column gap-3">
        @if (backLabel()) {
          <div
            class="flex align-items-center gap-2 cursor-pointer text-sm-semibold text-gray-600"
            (click)="backClicked.emit()"
          >
            <app-arrow direction="left" stroke="#535862" width="14px" height="14px"></app-arrow>
            <span>{{ backLabel() }}</span>
          </div>
        }
        <!-- Avatar/Icon + Title + Description -->
        <div class="flex gap-3 align-items-center">
          @if (showAvatar()) {
            @if (imageUrl()) {
              <div
                class="profile-picture-container"
                [style.background-image]="'url(\'' + imageUrl() + '\')'">
              </div>
            } @else {
              <ng-content select="[avatarIcon]"></ng-content>
            }
          }

          <div class="flex flex-column gap-1">
            <div class="flex justify-content-between align-items-center w-full">
              <div class="display-xs-semibold text-gray-900">
                {{ pageTitle() }}
              </div>
              @if (statusChipLabel()) {
                <p-chip
                  [label]="statusChipLabel()!"
                  [class]="statusChipClass() ?? ''"
                  class="ml-2 mt-2">
                </p-chip>
              }
            </div>
            <div class="flex align-items-center gap-2 text-md-regular text-gray-600">
              <ng-content select="[descriptionIcon]"></ng-content>
              {{ pageDescription() }}
            </div>
          </div>
        </div>
      </div>
      <!-- Right side: extra header content, bottom-aligned with the description (e.g. legend) -->
      <div class="page-header-actions align-self-end ml-auto"><ng-content select="[headerActions]"></ng-content></div>
      <!-- Right side: Buttons -->
      <div class="flex gap-2">
        @if (secondaryActionLabel()) {
          <app-button
            [btnSize]="ButtonSize.MD"
            [btnSeverity]="ButtonSeverity.SECONDARY"
            (btnClicked)="handleActionSecondary()"
          >
            <ng-content select="[secondaryIcon]"></ng-content>
            <div class="text-sm-semibold text-gray-700">
              {{ secondaryActionLabel() }}
            </div>
          </app-button>
        }

        @if (actionLabel()) {
          <app-button
            [btnSize]="ButtonSize.MD"
            [btnSeverity]="ButtonSeverity.PRIMARY"
            (btnClicked)="handleAction()"
          >
            <ng-content select="[buttonIcon]"></ng-content>
            <div class="text-sm-semibold text-gray-900">{{ actionLabel() }}</div>
          </app-button>
        }

        @if (thirdActionLabel()) {
          <app-button
            [btnSize]="ButtonSize.MD"
            [btnSeverity]="ButtonSeverity.PRIMARY"
            (btnClicked)="handleActionThird()"
          >
            <ng-content select="[thirdIcon]"></ng-content>
            <div class="text-sm-semibold text-base-white">
              {{ thirdActionLabel() }}
            </div>
          </app-button>
        }

        @if (showMenuIcon()) {
          <div
            class="cursor-pointer"
            (click)="menuIconClicked.emit()"
          >
            <div class="more-options">
<!--              <app-ellipsis-v-icon></app-ellipsis-v-icon>-->
            </div>
          </div>
        }
      </div>
    </div>
    @if (showDivider()) {
      <div class="page-divider"></div>
    }
  </div>

  <!-- Content -->
  <ng-content></ng-content>
<!--  <p-scrollpanel-->
<!--    [style]="{-->
<!--      width: '100%',-->
<!--      height: showAvatar() ? 'calc(100dvh - 270px)' : 'calc(100dvh - 237px)',-->
<!--    }"-->
<!--  >-->
<!--    <ng-content></ng-content>-->
<!--  </p-scrollpanel>-->
</div>
